import { usePortalOverview } from './usePortalOverview';
import { formatDay } from './portalUtils';
import './portal.css';

export function SessionsView() {
  const { data, isLoading, isError } = usePortalOverview();
  if (isLoading) return <div className="portal-page"><div className="portal-spinner">Loading…</div></div>;
  if (isError || !data) return <div className="portal-page"><div className="portal-error">Unable to load your sessions.</div></div>;

  const sessions = data.sessions ?? []; // newest first
  const total = sessions.length;
  const cancelledTotal = sessions.filter((s) => s.cancelled).length;

  // This calendar month. Use the LOCAL year-month (session dates are local
  // calendar dates) — toISOString() is UTC and skews the boundary by ~a day.
  const now = new Date();
  const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const thisMonth = sessions.filter((s) => s.date.startsWith(ym));
  const mCancelled = thisMonth.filter((s) => s.cancelled).length;
  const mAttended = thisMonth.length - mCancelled;
  const completion = thisMonth.length ? Math.round((mAttended / thisMonth.length) * 100) : 0;

  // Current streak: consecutive most-recent attended (non-cancelled) sessions.
  let streak = 0;
  for (const s of sessions) { if (s.cancelled) break; streak++; }

  return (
    <div className="portal-page portal-sessions">
      <div className="portal-page-header"><h1>Recent sessions</h1></div>

      <div className="portal-sessions-grid">
        <div className="portal-section portal-sessions-main">
          {total === 0 ? (
            <p className="portal-muted">No sessions logged yet.</p>
          ) : (
            sessions.map((s, i) => (
              <div key={i} className={`portal-session-row${s.cancelled ? ' cancelled' : ''}`}>
                <div className="portal-session-date">
                  {formatDay(s.date)}
                  {s.cancelled && <span className="portal-cancel-badge">Cancelled</span>}
                </div>
                {s.note && <div className="portal-session-note">{s.note}</div>}
              </div>
            ))
          )}
        </div>

        <aside className="portal-sessions-side">
          <div className="portal-section portal-attendance">
            <div className="portal-attendance-label">This month</div>
            <div className="portal-attendance-rows">
              <div><span>Attended</span><b>{mAttended}</b></div>
              <div><span>Cancelled</span><b>{mCancelled}</b></div>
              <div><span>Completion</span><b>{completion}%</b></div>
            </div>
            <div className="portal-attendance-divider" />
            <div className="portal-streak">🔥 {streak === 0 ? 'No active streak' : `${streak} in a row attended`}</div>
            <div className="portal-attendance-rows">
              <div><span>Total sessions</span><b>{total}</b></div>
              <div><span>Cancelled (all time)</span><b>{cancelledTotal}</b></div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
